import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[nameDetailDirective]',
})
export class NameDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}